import { capitalize, markRaw } from 'vue';

import { IconColoredDisplayAndVideo, IconColoredDooh } from '@/common/icons/colored';
import LineItemChannelType from '@/common/models/lineitem/LineItemChannelType.enum';
import { IOption } from '@/common/models/Option';
import i18n from '@/vueI18n';

export interface IOrganizationCustomFieldTypeOption {
  value: string;
  name: string;
  icon: any;
}

class LineItemChannelTypeOptions {
  static options(): IOption[] {
    return [
      {
        value: LineItemChannelType.OOH,
        name: capitalize(i18n.global.t('options.channelType.dooh')),
        icon: markRaw(IconColoredDooh),
      },
      {
        value: LineItemChannelType.DISPLAY_VIDEO,
        name: capitalize(i18n.global.t('options.channelType.displayVideo')),
        icon: markRaw(IconColoredDisplayAndVideo),
      },
    ];
  }
}

export default LineItemChannelTypeOptions;
